class PromoSticker extends HTMLElement {
  connectedCallback() {
    this.storageKey = this.dataset.storageKey;
    if (window.localStorage.getItem(this.storageKey) === 'true') {
      this.hidden = true;
      return;
    }
    const closeButton = this.querySelector('.promo-sticker__close');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.hidden = true;
        window.localStorage.setItem(this.storageKey, 'true');
      });
    }
  }
}

customElements.define('promo-sticker', PromoSticker);
